import React from "react"
import { graphql } from "gatsby"
import Image from "gatsby-image"
import parse from "html-react-parser"
import RelatedPosts from "../components/RelatedPosts"

import Layout from "../components/layout"
import Seo from "../components/seo"
import CalculateCalories from "../components/CalculateCalories"
import BasicImage from "../components/BasicImage"

import JsxParser from "react-jsx-parser"

const BlogPostTemplate = ({ data: { previous, next, post } }) => {
  const featuredImage = {
    fluid: post.featuredImage?.node?.localFile?.childImageSharp?.fluid,
    alt: post.featuredImage?.node?.alt || ``,
  }

  return (
    <Layout>
      <Seo
        title={post.acfMetaData.metaTitle}
        description={post.acfMetaData.metaDescription}
      />

      <article
        className="article"
        itemScope
        itemType="http://schema.org/Article"
      >
        <div className="container px-2">
          <div className="row justify-content-center">
            <div className="col-md-10 ">
              <p className="text-center mt-16 text-primary-600 text-md font-semibold">
                {post.categories.nodes[0].name}
              </p>
              <h1 className="text-center " itemProp="headline">
                {parse(post.title)}
              </h1>
              <header>
                {featuredImage?.fluid && (
                  <Image
                    className="max-w-4xl mx-auto mb-16 mt-16"
                    fluid={featuredImage.fluid}
                    alt={featuredImage.alt}
                  />
                )}
              </header>

              <div className="row justify-content-center post-content">
                <div className="col-md-12">
                  <section className="max-w-3xl mx-auto" itemProp="articleBody">
                    {
                      <JsxParser
                        allowUnknownElements
                        autoCloseVoidElements
                        renderInWrapper
                        showWarnings
                        components={{
                          CalculateCalories,
                          BasicImage,
                        }}
                        jsx={post.content}
                      />
                    }
                  </section>
                </div>
              </div>
            </div>
          </div>
        </div>
      </article>

      <div className="container">
        <RelatedPosts articles={post.related_posts.nodes} />
      </div>

      {/*<nav className="blog-post-nav">
        <ul
          style={{
            display: `flex`,
            flexWrap: `wrap`,
            justifyContent: `space-between`,
            listStyle: `none`,
            padding: 0,
          }}
        >
          <li>
            {previous && (
              <Link to={previous.uri} rel="prev">
                ← {parse(previous.title)}
              </Link>
            )}
          </li>

          <li>
            {next && (
              <Link to={next.uri} rel="next">
                {parse(next.title)} →
              </Link>
            )}
          </li>
        </ul>
      </nav>*/}
    </Layout>
  )
}

export default BlogPostTemplate

export const pageQuery = graphql`
  query BlogPostById(
    # these variables are passed in via createPage.pageContext in gatsby-node.js
    $id: String!
    $previousPostId: String
    $nextPostId: String
  ) {
    # selecting the current post by id
    post: wpPost(id: { eq: $id }) {
      id
      excerpt
      content
      title
      date(formatString: "MMMM DD, YYYY")
      acfMetaData {
        metaTitle
        metaDescription
      }
      categories {
        nodes {
          name
        }
      }
      related_posts {
        nodes {
          id
          title
          uri
          slug
          excerpt
          featuredImage {
            node {
              sourceUrl
              altText
              mediaDetails {
                sizes {
                  fileSize
                  sourceUrl
                }
              }
            }
          }
          categories {
            nodes {
              name
            }
          }
        }
      }

      featuredImage {
        node {
          altText
          localFile {
            childImageSharp {
              fluid(maxWidth: 1000, quality: 100) {
                ...GatsbyImageSharpFluid_tracedSVG
              }
            }
          }
        }
      }
    }

    # this gets us the previous post by id (if it exists)
    previous: wpPost(id: { eq: $previousPostId }) {
      uri
      title
    }

    # this gets us the next post by id (if it exists)
    next: wpPost(id: { eq: $nextPostId }) {
      uri
      title
    }
  }
`
